<script setup lang="ts">
import { useLangStore } from "@/stores/langStore";
import { useI18n } from "vue-i18n";
import { Lang } from "@/types/blogs";
import { onMounted } from "vue";
import router from "@/router";

const { locale } = useI18n();

const langStore = useLangStore();

onMounted(() => {
  locale.value = langStore.current;
});

function toggleLang(l: Lang) {
  langStore.setLang(l);
  router.go(0);
}
</script>

<template>
  <div class="pb-5 pt-5 border-t border-divider">
    <div class="flex items-center justify-center xl:mx-auto">
      <div
        class="flex rounded-full border border-muted overflow-hidden justify-center gap-1 px-1"
      >
        <button
          class="w-[37px] p-1 my-1 text-center sf-pro-xs font-medium transition-colors rounded-full"
          :class="
            langStore.current === 'ru' ? 'bg-brown text-white' : 'text-brown'
          "
          @click="toggleLang('ru')"
        >
          РУ
        </button>
        <button
          class="w-[37px] p-1 my-1 text-center sf-pro-xs font-medium transition-colors rounded-full"
          :class="
            langStore.current === 'en' ? 'bg-brown text-white' : 'text-brown'
          "
          @click="toggleLang('en')"
        >
          EN
        </button>
        <button
          class="w-[37px] p-1 my-1 text-center sf-pro-xs font-medium transition-colors rounded-full"
          :class="
            langStore.current === 'uk' ? 'bg-brown text-white' : 'text-brown'
          "
          @click="toggleLang('uk')"
        >
          УКР
        </button>
      </div>

      <span class="ml-5 sf-pro-xs text-muted">© 2025 Fengshui Style</span>
    </div>
  </div>
</template>
